/*
  Tap-to-pause for the scrolling marquees (snippets/marquee-pause.liquid).

  One choice covers every marquee on the page and is remembered across pages, since a
  shopper who stops one doesn't want the next one moving. The state lives on <html>
  (marquee-paused), so markup that a family switch or the homepage switcher swaps in
  is paused already, with nothing to re-bind. The buttons' accessible names follow it
  in CSS; only the mouse tooltip (title) is set here.
*/
(function () {
  if (window.JiYuMarqueePause) return;
  window.JiYuMarqueePause = true;

  var STORAGE_KEY = 'jiyu:marqueePaused';
  var root = document.documentElement;

  function readPaused() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writePaused(paused) {
    try {
      if (paused) localStorage.setItem(STORAGE_KEY, '1');
      else localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function labelFor(toggle) {
    var paused = root.classList.contains('marquee-paused');
    var span = toggle.querySelector(paused ? '.marquee-pause__label--play' : '.marquee-pause__label--pause');
    return span ? span.textContent.trim() : '';
  }

  function setTitle(toggle) {
    var label = labelFor(toggle);
    if (label) toggle.setAttribute('title', label);
  }

  root.classList.toggle('marquee-paused', readPaused());
  // Reveals the buttons (base-custom.css): without this script they would do nothing
  root.classList.add('marquee-pause-ready');

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-marquee-toggle]');
    if (!toggle) return;
    var paused = !root.classList.contains('marquee-paused');
    root.classList.toggle('marquee-paused', paused);
    // Hands the marquees to the shopper: pause-on-hover stops applying (CSS), so a
    // click to resume works while the pointer is still over the marquee
    root.classList.add('marquee-toggled');
    writePaused(paused);
    document.querySelectorAll('[data-marquee-toggle]').forEach(setTitle);
  });

  // Tooltip for buttons rendered or swapped in since the last toggle
  document.addEventListener('mouseover', function (event) {
    var toggle = event.target.closest('[data-marquee-toggle]');
    if (toggle) setTitle(toggle);
  });
})();
